import { AjaxResponse } from 'rxjs/ajax'

export type  Method = 'get' | 'put' |  'post' | 'delete'

export enum ContentType {
    urlencoded = 'application/x-www-form-urlencoded; charset=UTF-8',
}

export interface PathParams {
    [key: string]: string | number | undefined,
}

export interface TypedAjaxResponse<T> extends AjaxResponse {
    response: T,
}